























































import DictMixin from '@/mixins/dict-mixin';
import DatasourceServices from '@/services/datasource';
import { DatacollectDto, SyncColumnsInfo } from '@/services/datacollect';
import { mixins } from 'vue-class-component';
import { Component, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class DatacollectForm2 extends mixins(DictMixin) {
  @PropSync('formData') syncFormData!: DatacollectDto;

  dsSrv = new DatasourceServices();

  dsTypeList: any = [];
  dsList: any = [];
  tableList: any = [];

  created() {
    this.dsTypeList = [
      {key: 'MySQL', value: 'MySQL'},
      {key: 'PostgreSQL', value: 'PostgreSQL'},
      {key: 'SQLServer', value: 'SQLServer'},
      {key: 'Oracle', value: 'Oracle'},
      {key: 'elasticsearch', value: 'elasticsearch'},
      {key: 'mongoDB', value: 'mongoDB'},
      {key: 'kafka', value: 'kafka'},
      {key: 'hive', value: 'hive'},
      {key: 'hbase', value: 'hbase'},
      {key: 'csvFile', value: 'csvFile'},
      {key: 'oss', value: 'oss'},
      {key: 'restapi', value: 'restapi'},
      {key: 'redis', value: 'redis'},
      {key: 'doris', value: 'doris'}
    ];

    this.getDsList();
  }

  @Watch('syncFormData.sourceDsColumns.length')
  onFormDataChange(newVal: number, oldVal: number) {
    if(newVal !== oldVal) {
      if (this.syncFormData.syncConfig &&  this.syncFormData.syncConfig.length > 0) {
        let syncMappings: Array<SyncColumnsInfo> = [];
        let sourceTable =  this.syncFormData.syncConfig[0].sourceTable;
        this.syncFormData.syncConfig = [];

        if(this.syncFormData.sinkDsColumns 
            && this.syncFormData.sinkDsColumns.length > 0 ) {
          this.syncFormData.sinkDsColumns.forEach((val, idx) => {
            // sink为基础，匹配source, sink不能为空（【上一步】操作来调整字段结构）
            syncMappings[idx] = {};
            syncMappings[idx].sort = idx;
            syncMappings[idx].sinkTable = this.syncFormData.sinkDsTableName;
            syncMappings[idx].sinkColumnNameEn = val.columnNameEn;
            syncMappings[idx].sinkColumnNameCn = val.columnNameCn;
            syncMappings[idx].sourceTable = sourceTable;
          })
        }
        this.syncFormData.syncConfig = syncMappings.concat();
      }
    }
  }

  @Watch('syncFormData.id')
  async getDsList() {
    if (this.syncFormData.id) {
      this.dsList = await this.dsSrv.getList({ status_eq: 0, dsType_eq: this.syncFormData.sourceDsType });
      this.tableList = await this.dsSrv.tables({ status_eq: 0, sourceId_eq: this.syncFormData.sourceDsId });
    } else {
      this.dsList = await this.dsSrv.getList({ status_eq: 0 });
    }
  }

  async onChangeDsType(e: string) {
    this.syncFormData.sourceDsType = e;
    this.dsList = await this.dsSrv.getList({ status_eq: 0, dsType_eq: e });
    this.$forceUpdate();
  }

  async onChangeDs(e: number) {
    this.syncFormData.sourceDsId = e;
    let source = this.dsList.filter((v: any) => v.id == e);
    this.syncFormData.sourceDsName = source && source.length > 0 ? source[0].dsName : '';
    if(!this.syncFormData.sourceDsType) { this.syncFormData.sourceDsType = source.dsType; } 
    this.tableList = await this.dsSrv.tables({ status_eq: 0, sourceId_eq: e });
    this.$forceUpdate();
  }

  async onChangeTable(e: number) {
    this.syncFormData.sourceDsTableId = e;
    let table = this.tableList.filter((v: any) => v.id == e);
    this.syncFormData.sourceDsTableName = table && table.length > 0 ? table[0].tableNameEn : '';

    this.syncFormData.sourceDsColumns = await this.dsSrv.columns({ status_eq: 0, tableId_eq: e });

    this.$forceUpdate();
  }

  filterOption(input: string, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  
  removeList(index: number) {
    this.syncFormData.sourceDsColumns && this.syncFormData.sourceDsColumns.splice(index, 1);
  }

  columns = [{
      title: '字段物理名',
      dataIndex: 'columnNameEn',
      key: 'columnNameEn',
      width: 120,
    },
    {
      title: '字段逻辑名',
      dataIndex: 'columnNameCn',
      key: 'columnNameCn',
      width: 120,
      scopedSlots: { customRender: 'nameCn' },
    },
    {
      title: '字段物理类型',
      dataIndex: 'dataTypeEn',
      key: 'dataTypeEn',
      width: 80,
    },
    {
      title: '字段逻辑类型',
      dataIndex: 'dataTypeCn',
      key: 'dataTypeCn',
      width: 80,
    },
    {
      title: '主键',
      dataIndex: 'pkFlag',
      key: 'pkFlag',
      width: 80,
      scopedSlots: { customRender: 'pkFlag' },
    },
    {
      title: '分区字段',
      dataIndex: 'partitionFlag',
      key: 'partitionFlag',
      width: 80,
      scopedSlots: { customRender: 'partitionFlag' },
    },
    {
      title: '增量字段',
      dataIndex: 'incrementFlag',
      key: 'incrementFlag',
      width: 80,
      scopedSlots: { customRender: 'incrementFlag' },
    },
    {
      title: '启用',
      dataIndex: 'status',
      key: 'status',
      width: 80,
      scopedSlots: { customRender: 'status' },
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      width: 50,
      scopedSlots: { customRender: 'operation' },
    },
  ];

}
